<script setup>
import { secondaryDividerBorder } from '@/Common/util/tailwind/colorConstants'
import { WrenchScrewdriverIcon } from '@heroicons/vue/24/outline'
import { computed, ref } from 'vue'
import ActivityDisclosure from './ActivityDisclosure.vue'
import ActivityToolCall from './ActivityToolCall.vue'
import { toolActivityState, toolGroupLabel } from './activityLabels'

const props = defineProps({
  parts: { type: Array, required: true },
  status: { type: String, default: 'complete' },
})

const open = ref(false)
const hasOpened = ref(false)
function toggleOpen() {
  hasOpened.value = true
  open.value = !open.value
}
const states = computed(() =>
  props.parts.map((part) => toolActivityState(part, props.status))
)
const running = computed(() => states.value.includes('running'))
const label = computed(() => toolGroupLabel(props.parts, props.status))
</script>

<template>
  <div class="min-w-0" data-testid="activity-tool-group">
    <ActivityDisclosure
      :open="open"
      :running="running"
      :label="label"
      :error="states.includes('error')"
      :icon="WrenchScrewdriverIcon"
      data-testid="activity-group-disclosure"
      @toggle="toggleOpen"
    />
    <div
      v-if="hasOpened"
      v-show="open"
      class="ml-2 mt-1 min-w-0 space-y-1 border-l pl-3"
      :class="secondaryDividerBorder"
    >
      <ActivityToolCall
        v-for="(part, index) in parts"
        :key="part.toolCallId || part.id || index"
        :part="part"
        :status="status"
      />
    </div>
  </div>
</template>
